import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TileBase } from '@app/super/tile-base';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { NumberFormatPipe } from '@commonPipes/numberFormat';
import { IFocusTile } from '@interfaces/iTile';
import { WatermarkComponent } from '../../../components/watermark/watermark.component';
import { TileBorderComponent } from '../tile-border/tile-border.component';

@Component({
	selector: 'app-focus-tile',
	templateUrl: './focus-tile.component.html',
	styleUrls: ['./focus-tile.component.scss'],
	imports: [TileBorderComponent, NgClass, WatermarkComponent, TranslatePipe, NumberFormatPipe]
})
export class FocusTileComponent extends TileBase implements OnInit {
	@Input() tile: IFocusTile

	constructor() { super() }

	ngOnInit(): void {
	}

}
